import React, { useState } from 'react';
import styled from 'styled-components';

import { observer } from 'mobx-react-lite';
import HeaderIcon from '../../assets/windows.svg';
import { MovieDisplay } from '../../utils/Video';
import Page from '../base/Page';
import { colors } from '../const/Styles';
import { VideoMovie } from '../video/PlayingVideoCard';
import PlayerHeaderNavigation from './navigation/PlayerHeaderNavigation';
import { useHistory, useLocation } from 'react-router-dom';
import GoBack from '../../assets/goback.svg';
import { ReactSVG } from 'react-svg';
import { Routes } from '../const/Routes';
import Api from '../../utils/Api';
import VideoComposer from '../video/VideoComposer';
import { FooterButton } from '../video/VideoComposer/Footer';

const ContentContainer = styled.section`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    height: 100%;
    width: 100%;
    background-color: ${colors.white};
`;

const VideoContainer = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    background-color: ${colors.white};
`;

const GoBackIcon = styled.i`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 120px;
    height: 80px;
    position: absolute;
    top: 50px;
    right: 50px;
    color: ${colors.footerIconSelected};
    font-size: 13px;
    svg {
        height: 40px;
        width: 40px;
    }
`;

const PlayMoviePage: React.FC = () => {
    const location = useLocation<MovieDisplay>();
    const { state } = location;
    const [saveCounter, setSaveCounter] = useState<number>(0);
    const {
        id,
        src,
        filename,
        customer_id_or_staff_id,
        created_at,
        tool_image_filename,
        tool_image_filepath,
    } = state;
    const videoMovie: VideoMovie = {
        id: Number(id),
        type: 'movie',
        filepath: src ?? '',
        filename: filename,
        customerIdOrStaffId: customer_id_or_staff_id,
        movieCreatedAt: created_at,
        toolImageFilename: tool_image_filename,
        toolImageFilePath: tool_image_filepath,
    };

    const history = useHistory();

    const handleClickDelete = async () => {
        if (!confirm('このスイング映像を\n削除してもよろしいですか？')) {
            return;
        }

        try {
            const result = await Api.deleteStaffMovie(Number(id));

            if (!result) {
                throw Error(`Failed to delete the video. id: ${id}`);
            }

            alert('スイング映像を削除しました');
            await Api.fetchStaffMovies(Number(result.customer_id_or_staff_id));
            history.push({
                pathname: Routes.MERCHANT,
                state: { changePageValue: true },
            });
        } catch (e) {
            alert('スイング映像の削除に失敗しました');
            throw e;
        }
    };

    const handleClickBackIcon = () => {
        history.push({
            pathname: Routes.MERCHANT,
            state: { changePageValue: true },
        });
    };

    const extraButtons: FooterButton[] = [
        {
            label: '削除',
            onClick: async () => {
                await handleClickDelete();
            },
        },
    ];

    return (
        <Page title='スイング一覧' headerIcon={HeaderIcon ?? ''}>
            <ContentContainer>
                <PlayerHeaderNavigation>スイング再生</PlayerHeaderNavigation>
                <GoBackIcon onClick={handleClickBackIcon}>
                    <ReactSVG src={GoBack ?? ''}></ReactSVG>
                    コーチ一覧に戻る
                </GoBackIcon>
                <VideoContainer>
                    <VideoComposer
                        isBackgroundDark={false}
                        ownerId={state.customer_id_or_staff_id}
                        toolImageFilePath={state.tool_image_filepath}
                        movieSequence={1}
                        createdAt={state.created_at}
                        club={state.club}
                        yard={state.yards}
                        isBestSwing={state.desirable}
                        playbackPosition={state.playback_position}
                        videoSrc={videoMovie}
                        height={601}
                        width={416}
                        saveCounter={saveCounter}
                        setSaveCounter={setSaveCounter}
                        extraButtons={extraButtons}
                        isShowBestSwing={false}
                    />
                </VideoContainer>
            </ContentContainer>
        </Page>
    );
};

export default observer(PlayMoviePage);
